import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../stylesheets/resource.scss";
import { Col, FormGroup, Label, Button, Input } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { Feedback_APIs } from "./Feedback_APIs";
import { UserConsumer } from "../../UserContext";
import { Ticket_Variables } from "../ticketModule/variables/Ticket_Variables";
import PageLoader from "../../components/PageLoader";
import { Config, Routes } from "../../configurations/config";
import FormStatus from "../../components/FormStatus";
import moment from "moment";
import CustomReactSelect from "../../components/CustomReactSelect";
import { AlertPopups } from "../../components/AlertPopups";
import { TableDateFormat } from "../Dashboard/DashboardVariables";

const validation = Yup.object().shape({
	selectStatus: Yup.string()
		.required("Select Priority")
		.typeError("Invalid input")
		.nullable(),
	Description: Yup.string()
		.required("Description is required")
		.typeError("Invalid input")
		.max(600, "Max 600 characters allowed"),
	title: Yup.string()
		.required("Title is required")
		.typeError("Invalid input")
		.max(500, "Max 500 characters allowed"),
});
let token = null;

export class FeedbackDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			feedbackDetails: {},
			showLoader: true,
			attachment: null,
			urlPath: "",
			selectStatus: null,
			feedbackId: parseInt(this.props.match.params.feedbackId),
			assignee: null,
			comment: "",
		};
	}
	componentDidMount() {
		if (
			window.location.pathname ===
			`/feedbackStatusDetails/${this.props.match.params.feedbackId}`
		) {
			this.setState({ urlPath: window.location.pathname });
		}
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${Feedback_APIs.GetFeedbackDetails_API}${this.props.match.params.feedbackId}`,
				{ headers: headers }
			)
			.then((res) => {
				this.setState({
					showLoader: false,
					feedbackDetails: res.data,
					attachment:
						res.data.attachedFile !== "" &&
						res.data.attachedFile !== null
							? Config.server_url + res.data.attachedFile
							: "N/A",
					comment: res.data.comments,
					assignee: Ticket_Variables.devsList.find(
						(item) => item.value == res.data.assignedTo
					),
					selectStatus:
						res.data.bugStatusEnum === 1
							? { value: 1, label: "Pending " }
							: res.data.bugStatusEnum === 2
							? { value: 2, label: "InProgress" }
							: res.data.bugStatusEnum === 3
							? { value: 3, label: "Completed" }
							: res.data.bugStatusEnum === 4
							? { value: 4, label: "Deferred" }
							: { value: 0, label: "Pending" },
				});
			});
	}

	handleStatusChange = (val) => {
		this.setState({ ...this.state, selectStatus: val });
	};

	handleChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

	onSubmit = () => {
		if (this.state.assignee) {
			const { feedbackDetails } = this.state;
			let data = {
				title: feedbackDetails.title,
				Id: parseInt(this.props.match.params.feedbackId),
				description: feedbackDetails.description || "",
				comments: this.state.comment,
				assignedTo: this.state.assignee.value,
				priority: feedbackDetails.priority,
				status: this.state.selectStatus.value,
			};
			const headers = {
				Authorization: `Bearer ${token}`,
			};
			axios
				.put(
					`${Feedback_APIs.EditFeedback_API}${this.props.match.params.feedbackId}`,
					data,
					{ headers: headers }
				)
				.then((res) => {
					AlertPopups.successAlert.fire({
						text: "Ticket Updated",
					});
					this.props.history.push(Routes.ReportedBugs);
				});
		} else {
			AlertPopups.ErrorAlert.fire({
				text: "Select Form Value",
			});
		}
	};

	goBack = () => {
		let history = this.props.history;
		if (history.location.state !== undefined) {
			if (history.location.state.showFeedback) {
				history.push({
					pathname: Routes.Bug,
					state: {
						currentPage: history.location.state.currentPage,
						showFeedback: history.location.state.showFeedback,
					},
				});
			} else
				history.push({
					pathname: Routes.ReportedBugs,
					state: { currentPage: history.location.state.currentPage },
				});
		} else history.push(Routes.ReportedBugs);
	};
	render() {
		let { showLoader, feedbackDetails } = this.state;
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					if (showLoader) {
						return <PageLoader />;
					} else
						return (
							<div className="container-fluid pl-4 pr-4">
								<FormStatus
									title="Reported Bug"
									formStatus={
										feedbackDetails.bugStatusEnum === 1
											? "Pending"
											: feedbackDetails.bugStatusEnum ===
											  2
											? "InProgress"
											: feedbackDetails.bugStatusEnum ===
											  3
											? "Completed"
											: feedbackDetails.bugStatusEnum ===
											  4
											? "Deferred"
											: "Pending"
									}
									className="create-request d-flex align-items-center"
									onClick={this.goBack}
									navigateBack={true}
								/>

								<Formik
									initialValues={this.state}
									enableReinitialize={true}
									validationSchema={validation}
									validateOnChange={true}
									onSubmit={() => this.onSubmit()}
								>
									{({ errors }) => (
										<form className=" detailsScreen col-md-12">
											<FormGroup
												row
												id="row0"
												className="form-group mb-0 row topBorders mb-0"
											>
												<Label sm={12}>
													Feedback id#{" "}
													{
														this.props.match.params
															.feedbackId
													}
												</Label>
											</FormGroup>
											<FormGroup
												row
												sm={12}
												className="bottom-spacing row1 mb-0"
											>
												<Label sm={3}>Item Name:</Label>
												<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow description">
													<span
														sm={3}
														className="dataSpan"
													>
														{feedbackDetails.title ===
														null
															? "N/A"
															: feedbackDetails.title}
													</span>
												</div>
												<Label sm={3}>
													Created By:
												</Label>
												<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
													<span className="dataSpan">
														{
															feedbackDetails.empName
														}
													</span>
												</div>
											</FormGroup>
											<FormGroup
												row
												className="bottom-spacing row2"
											>
												<Label sm={3}>
													Description
												</Label>
												<div className="col-sm-9 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow description">
													<span className="dataSpan">
														{feedbackDetails.description
															? feedbackDetails.description
															: "N/A"}
													</span>
												</div>
											</FormGroup>
											{!this.state.urlPath ? (
												<FormGroup
													row
													className="bottom-spacing row1 mb-0"
												>
													<Label sm={3}>
														Status:
													</Label>
													<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
														<span
															sm={3}
															className="dataSpan"
														>
															{feedbackDetails.bugStatusEnum ===
															1
																? "Pending"
																: feedbackDetails.bugStatusEnum ===
																  2
																? "InProgress"
																: feedbackDetails.bugStatusEnum ===
																  3
																? "Completed"
																: feedbackDetails.bugStatusEnum ===
																  4
																? "Deferred"
																: "Pending"}
														</span>
													</div>
													<Label sm={3}>
														Priority:
													</Label>
													<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
														<span
															sm={3}
															className="dataSpan"
														>
															{feedbackDetails.priority ===
															1
																? "High"
																: feedbackDetails.priority ===
																  2
																? "Medium"
																: feedbackDetails.priority ===
																  3
																? "Low"
																: feedbackDetails.priority}
														</span>
													</div>
												</FormGroup>
											) : (
												<>
													<FormGroup
														row
														className="bottom-spacing row1 mb-0"
													>
														<Label
															for="setStatus"
															sm={3}
														>
															Status
														</Label>
														<Col sm={9}>
															<CustomReactSelect
																options={
																	Ticket_Variables.feedbackStatus
																}
																name="setStatus"
																id="selectItems"
																placeholder=""
																bsSize="sm"
																styles={
																	Ticket_Variables.react_select_style
																}
																onChange={(
																	value
																) =>
																	this.handleStatusChange(
																		value
																	)
																}
																value={
																	this.state
																		.selectStatus
																}
																className={
																	errors.selectStatus
																		? "invalid"
																		: ""
																}
															/>
														</Col>
													</FormGroup>
													<FormGroup
														row
														className={`bottom-spacing ${
															this.state.urlPath
																? "row2"
																: "row1"
														}`}
													>
														<Label sm={3}>
															Priority:
														</Label>
														<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
															<span
																sm={3}
																className="dataSpan"
															>
																{feedbackDetails.priority ===
																1
																	? "High"
																	: feedbackDetails.priority ===
																	  2
																	? "Medium"
																	: feedbackDetails.priority ===
																	  3
																	? "Low"
																	: feedbackDetails.priority}
															</span>
														</div>
														<Label
															for="setStatus"
															sm={3}
														>
															Assign to:{" "}
															<span className="required">
																*
															</span>
														</Label>
														<Col sm={3}>
															<CustomReactSelect
																options={
																	Ticket_Variables.devsList
																}
																name="assignee"
																id="assignee"
																placeholder="Please Select an assignee"
																bsSize="sm"
																styles={
																	Ticket_Variables.react_select_style
																}
																onChange={(
																	val
																) =>
																	this.setState(
																		{
																			...this
																				.state,
																			assignee:
																				val,
																		}
																	)
																}
																value={
																	this.state
																		.assignee
																}
															/>
														</Col>
													</FormGroup>
													<FormGroup
														row
														className="bottom-spacing row1"
													>
														<Label
															for="Comments"
															sm={3}
														>
															Comment
														</Label>
														<Col sm={9}>
															<Input
																type="textarea"
																name="comment"
																id="comment"
																disabled={
																	this.state
																		.selectStatus
																		.value !==
																		3 &&
																	this.state
																		.selectStatus
																		.value !==
																		4
																}
																className={
																	"h-auto"
																}
																onChange={(
																	event
																) =>
																	this.handleChange(
																		event
																	)
																}
																value={
																	this.state
																		.comment
																}
																maxLength="600"
															/>
														</Col>
													</FormGroup>
												</>
											)}
											<FormGroup
												row
												className={`bottom-spacing bottomBorders ${
													this.state.urlPath
														? "row1"
														: "row2"
												}`}
											>
												<Label sm={3}>
													Request Date
												</Label>
												<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
													<span className="dataSpan">
														{moment(
															feedbackDetails.createdAt
														).format(
															TableDateFormat
														)}
													</span>
												</div>
												<Label sm={3}>
													Attachment:
												</Label>
												<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
													<span className="dataSpan">
														{feedbackDetails.attachedFile ? (
															<a
																id="imageName"
																href={
																	this.state
																		.attachment
																}
																target="_blank"
																className="dataSpan"
																rel="noopener noreferrer"
																style={{
																	textDecoration:
																		"underline",
																}}
															>
																{feedbackDetails.attachedFile.slice(
																	20,
																	40
																)}
															</a>
														) : (
															"N/A"
														)}
													</span>
												</div>
											</FormGroup>
											{window.location.pathname.includes(
												Routes.FeedbackStatusDetails
											) ? (
												<div className="btns">
													<Button
														className="submit-btn"
														onClick={() =>
															this.onSubmit()
														}
													>
														Submit
													</Button>
												</div>
											) : null}
										</form>
									)}
								</Formik>
							</div>
						);
				}}
			</UserConsumer>
		);
	}
}

export default FeedbackDetails;
